import React from 'react';
import { Outlet } from 'react-router-dom';
import CookiePolicyNotification from 'src/components/CookiePolicyNotification';
import Header from '../Header';
import Footer from '../Footer/Footer';
import styles from './styles.module.scss';

type Props = {
  showTitle?: boolean;
  showMenu?: boolean;
};

const BaseLayout: React.FC<Props> = ({ showTitle, showMenu }) => (
  <>
    <CookiePolicyNotification />
    <div className={styles['header']}>
      <Header showTitle={showTitle} showMenu={showMenu} />
    </div>
    <div className={styles['content']}>
      <Outlet />
    </div>
    <div className={styles['footer']}>
      <Footer />
    </div>
  </>
);

export default BaseLayout;
